module.exports = __webpack_public_path__ + "static/assets/90eaf6469dbf3a808a3d9739cc77358d.mp3";